# Rule words for the position-page check list. The monitor owns category,
# description, and owner. This asks for those fields only.
query workforceGuardrailRuleLabels {
  workforceGuardrailMonitor {
    rules {
      id
      name
      description
      category
      ownerRole
    }
  }
}
